require("core-js/modules/es6.object.assign");

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var ReactPrimitives = require('../ReactPrimitives');

var _require = require('react-native-web'),
    Animated = _require.Animated,
    StyleSheet = _require.StyleSheet,
    View = _require.View,
    Text = _require.Text,
    Image = _require.Image,
    Platform = _require.Platform,
    TouchableWithoutFeedback = _require.TouchableWithoutFeedback,
    Dimensions = _require.Dimensions,
    Easing = _require.Easing;

function getDefault(m) {
  return m.__esModule === true ? m["default"] : m;
}

var StyleRegistry = null;

try {
  StyleRegistry = getDefault(require('react-native-web/dist/cjs/exports/StyleSheet/createStyleResolver'))();
} catch (e) {
  StyleRegistry = getDefault(require('react-native-web/dist/cjs/exports/StyleSheet/ReactNativeStyleResolver'));
}

var emptyObject = {};

var resolve = function resolve(style) {
  return StyleRegistry.resolve(style) || emptyObject;
};

ReactPrimitives.inject({
  View: View,
  Text: Text,
  Image: Image,
  Easing: Easing,
  Animated: Animated,
  StyleSheet: _extends({}, StyleSheet, {
    resolve: resolve
  }),
  Platform: {
    OS: Platform.OS,
    Version: Platform.Version
  },
  Dimensions: Dimensions,
  Touchable: TouchableWithoutFeedback
});